module.exports = __webpack_public_path__ + "img/noimage.8b5fd06f.jpg";